"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { useSelectedLayoutSegment } from "next/navigation";

export function NavLink({
  href,
  children,
  index = false,
  target = "_self",
  className = "",
}: {
  href: string;
  children: React.ReactNode;
  index?: boolean;
  target?: string;
  className?: string;
}) {
  const segment = useSelectedLayoutSegment();

  const active = index ? segment === null : href === `/dashboard/${segment}`;

  return (
    <Link
      href={href}
      target={target}
      className={cn(
        `flex items-center py-2.5 px-4 hover:bg-white/10 dark:hover:bg-[#788790]/10 hover:text-theme-accent rounded-md whitespace-nowrap ${className}`,
        {
          "bg-theme-accent dark:bg-[#788790]/20 text-white dark:text-theme-accent": active,
          "bg-theme-black3 dark:bg-[#DBDFE4] text-theme-accent": !active,
        }
      )}
    >
      {children}
    </Link>
  );
}
